var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMargin24Filled = function SvgIconMargin24Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 5.533a2.733 2.733 0 0 0-2.733 2.734v15.466a2.733 2.733 0 0 0 2.734 2.733h12.8a2.733 2.733 0 0 0 2.733-2.733V8.267A2.733 2.733 0 0 0 22.4 5.533H9.6Zm7.503 4.233-.002-.001a1.526 1.526 0 0 0-2.212 0l-3.006 3.152 1.35 1.288 1.765-1.85v7.285l-1.757-1.843-1.351 1.288 3.006 3.153a1.526 1.526 0 0 0 2.213 0l.001-.002 3.004-3.15-1.35-1.289-1.766 1.851v-7.286l1.758 1.843 1.351-1.288-3.004-3.15Z",
    fill: "current"
  })));
};
export default SvgIconMargin24Filled;